module.exports = __webpack_public_path__ + "static/media/bar-chart.315e0f52.svg";